import * as React from 'react'
import Cropper from 'react-easy-crop'
import './style.scss'

export interface IImageCrop {
  x: number
  y: number
  width: number
  height: number
}

interface IProps {
  image: any
  onSubmit: (image: any) => void
  onCancel: () => void
}

interface IState {
  crop: { x: number; y: number }
  zoom: number
  croppedAreaPixels: IImageCrop
}

export class CropImage extends React.PureComponent<IProps, IState> {
  state = {
    crop: { x: 0, y: 0 },
    zoom: 1,
    croppedAreaPixels: {
      x: 0,
      y: 0,
      width: 0,
      height: 0
    }
  }

  onCropComplete = (croppedArea, croppedAreaPixels: IImageCrop) => {
    this.setState({ croppedAreaPixels })
  }

  onCropChange = crop => {
    this.setState({ crop })
  }

  onZoomChange = zoom => {
    this.setState({ zoom })
  }

  createImage = url =>
    new Promise<HTMLImageElement>((resolve, reject) => {
      const image = new Image()
      image.addEventListener('load', () => resolve(image))
      image.addEventListener('error', error => reject(error))
      image.setAttribute('crossOrigin', 'anonymous') // needed to avoid cross-origin issues on CodeSandbox
      image.src = url
    })

  getCroppedImg = async (imageSrc, pixelCrop) => {
    const image = await this.createImage(imageSrc)
    const canvas = document.createElement('canvas')
    canvas.width = pixelCrop.width
    canvas.height = pixelCrop.height
    const ctx = canvas.getContext('2d')
    ctx!.fillStyle = 'white'
    ctx!.fillRect(0, 0, pixelCrop.width, pixelCrop.height)

    ctx!.drawImage(
      image,
      pixelCrop.x,
      pixelCrop.y,
      pixelCrop.width,
      pixelCrop.height,
      0,
      0,
      pixelCrop.width,
      pixelCrop.height
    )

    // As Base64 string
    // return canvas.toDataURL('image/jpeg');

    // As a blob
    console.log(canvas.toDataURL('image/jpeg'))
    return new Promise((resolve, reject) => {
      canvas.toBlob((file: Blob) => {
        resolve(file)
      }, 'image/jpeg')
    })
  }

  onChoose = () => {
    const { onSubmit } = this.props
    this.getCroppedImg(this.props.image, this.state.croppedAreaPixels).then(
      image => {
        console.log(image)
        onSubmit(image)
      }
    )
  }

  render() {
    const { image, onCancel } = this.props
    const { crop, zoom } = this.state
    return (
      <div className="crop-image">
        <Cropper
          image={image}
          crop={crop}
          zoom={zoom}
          aspect={1}
          cropShape="round"
          showGrid={false}
          onCropChange={this.onCropChange}
          onZoomChange={this.onZoomChange}
          onCropComplete={this.onCropComplete}
          classes={{
            containerClassName: 'crop-container',
            imageClassName: 'cropped-image',
            cropAreaClassName: 'cropped-area'
          }}
        />
        <div className="controls">
          <button className="cancel" onClick={onCancel}>
            Cancel
          </button>
          <button className="choose" onClick={this.onChoose}>
            Choose
          </button>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/CropImage/index.tsx